import { isAttributionEnabledEnv } from './utmAttribution';

export type Action =
	| 'explore_all_cases_click'
	| 'view_cases_click'
	| 'sign_up_click'
	| 'file_your_claim_click'
	| 'verify_account_click'
	| 'create_account_click'
	| 'create_account_google_click'
	| 'create_account_microsoft_click'
	| 'confirm_account_details_click'
	| 'first_sign_in_click'
	| 'faq_click'
	| 'contact_us_click';

type Category = 'landing' | 'clientapp' | 'lawyerapp';

interface customEventProps {
	action: Action;
	category: Category;
	label: string;
	value?: string;
	pageReferrer?: string;
	deviceType?: string;
	deviceOs?: string;
	callback?: () => void;
}

export const customEvent = async ({
	action,
	category,
	label,
	value,
	pageReferrer,
	callback,
}: customEventProps): Promise<void> => {
	if (!isAttributionEnabledEnv()) {
		if (callback) callback();
		return;
	}

	// In staging/production, try to send the event but ensure callback executes
	try {
		// Set a timeout as a fallback for the callback
		const fallbackTimeout = setTimeout(() => {
			if (callback) callback();
		}, 500); // 500ms is a reasonable wait time for GA

		// Check if gtag is available (not blocked by extensions/adblockers)
		if (typeof window !== 'undefined' && (window as any).gtag) {
			await (window as any).gtag('event', action, {
				event_category: category,
				event_label: label,
				value: value,
				page_referrer: pageReferrer,
				event_callback: () => {
					clearTimeout(fallbackTimeout); // Cancel timeout if GA responds
					if (callback) callback();
				},
			});
		} else {
			// If gtag is not available (blocked), execute callback immediately
			clearTimeout(fallbackTimeout);
			if (callback) callback();
		}
	} catch (error) {
		// If any error occurs, still execute the callback
		if (callback) callback();
	}
};
